import { GetListRequestParams, GetListResponse, instance } from "libs/api";

import { ApiRoutesContent } from "../../constants/enums";
import { AnnouncementsHistoryListItem } from "../../content.types";

export const requestAnnouncementsHistory = async (
  params: GetListRequestParams
): Promise<GetListResponse<AnnouncementsHistoryListItem>> => {
  return await instance.get(ApiRoutesContent.Announcement, { params });
};
